export const getStyled = (theme) => ({
  contactsListWrapper: {
    position: 'relative',
    display: 'flex',
    height: '100%',
    flexDirection: 'column',
    overflow: 'hidden',
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    backgroundColor: theme.custom.colors.defaultBackground,
  },

  contactsList: {
    backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#192734',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    width: '100%',
    padding: '0 12px 0 0',
    overflowY: 'auto',
    scrollbarWidth: 'none',
    ...theme.custom.scrollbarStyles,
  },

  contactsListHeader: {
    color: 'rgb(67, 83, 105)',
    zIndex: 2,
    backgroundColor: 'white',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  serachInputWrapper: {
    flex: 1,
    maxHeight: 35,
    background: theme.custom.colors.total,
    display: 'flex',
    borderRadius: 40,
    padding: 2,
    borderColor: '#aaa',
    borderWidth: '1px',
    borderStyle: 'solid',
    marginTop: theme.spacing(0.8),
    marginBottom: theme.spacing(0.8),
    marginLeft: theme.spacing(0.8),
    marginRight: theme.spacing(0.8),
    backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#192734',
  },
  searchIcon: {
    color: 'grey',
    marginLeft: 1,
    marginRight: 1,
    alignSelf: 'center',
  },
  searchInput: {
    flex: 1,
    border: 'none',
    borderRadius: 30,
    paddingTop: '3px',
  },
});
